import React from 'react';
import { Form, Row, SonForm, SubmitButton, Textarea, useForm } from '../../../_lib/Form2';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

function PersonalDataProcessingTextEdit({ form }: { form: SonForm<any> }) {
  const { t } = useSonTranslation('PersonalDataProcessingText');
  const { formProps, params, fetchState } = useForm({ form });

  return (
    <Form {...formProps}>
      <Row>
        <Textarea
          label={t('headline')}
          helpText={t('edit.inputs.helpText')}
          param={params.getByName('son_portal_personal_data_processing_text')}
        />
      </Row>
      <SubmitButton
        buttonLabel={t('Form:save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}

export const PersonalDataProcessingTextEditView = asFetchableView(PersonalDataProcessingTextEdit);
